// removed by extract-text-webpack-plugin
module.exports = {"previewButton":"_3Q7hy","addToCart":"_3oVHA"};